import { render, staticRenderFns } from "./mod-redeem.vue?vue&type=template&id=5ffc67f0"
import script from "./mod-redeem.vue?vue&type=script&lang=js"
export * from "./mod-redeem.vue?vue&type=script&lang=js"
import style0 from "./_scss/redeem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports